export default __webpack_public_path__ + "static/dynamic-compound-transitive-bd90f13334e4c36e981f68c31f70ba1e.svg";